import React from 'react'
import Link from 'next/link'
import Sidebar from 'components/Sidebar'
import { THEME } from 'utils'

const FavoritesPageActionPrompt = ({ type = 'signin' }) => {
  const title = type === 'signin' ? 'Sign In To Add Favorites' : 'Add Your Favorites'

  const action =
    type === 'signin' ? (
      <Link href='/account/signin'>
        <a className='btn btnPrimary'>Sign In</a>
      </Link>
    ) : (
      <>
        <Link href='/account/favorites'>
          <a className='bs-favoritesUpsell__link' />
        </Link>
        <style jsx>{`
          .bs-favoritesUpsell__link {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: auto;
            position: relative;
            background: #fff;
            width: 3rem;
            height: 3rem;
            border-radius: 50%;
            border: 1px solid #f1f1f1;
          }
          .bs-favoritesUpsell__link:before {
            content: '+';
            position: absolute;
            margin-top: -3px;
            margin-left: 1px;
            left: 50%;
            top: 50%;
            right: auto;
            transform: translate(-50%, -50%);
            font-family: ${THEME.FONTS.HELVETICA};
            font-size: 2.5rem;
            font-weight: 400;
            color: #999;
          }
        `}</style>
      </>
    )

  const prompt = (
    <>
      <section className='bs-favoritesUpsell'>
        <h2 className='bs-favoritesUpsell__title'>{title}</h2>
        <p className='bs-favoritesUpsell__text'>
          Select your favorite shows and bloggers to personalize your feed.
          <br />
          You can add or remove any of your favorites at any time.
        </p>
        {action}
      </section>
      <style jsx>{`
        .bs-favoritesUpsell {
          padding: 2rem 1rem;
          text-align: center;
          background: #fff;
        }
        .bs-favoritesUpsell__title {
          font-family: ${THEME.FONTS.HELVETICA};
          margin: 0 0 0.5rem;
          text-align: center;
          font-size: 1.875rem;
          font-weight: 600;
          color: ${THEME.COLORS.TEXTCOLOR};
          line-height: 1.2;
          text-align: center;
        }
        .bs-favoritesUpsell__text {
          text-align: center;
          font-family: ${THEME.FONTS.HELVETICA};
          font-size: 1rem;
        }
      `}</style>
    </>
  )

  return (
    <>
      <div className='container'>
        <div className='row row--main'>
          <div className='col col--main'>
            <div className='promptContainer'>{prompt}</div>
          </div>
          <div className='col col--sidebar'>
            <Sidebar adTag='Feed' />
          </div>
        </div>
      </div>
      <style jsx>{`
        .container > .row {
          display: grid;
          grid-template-columns: 1fr 300px;
          grid-column-gap: 30px;
          margin-left: 0;
          margin-right: 0;
        }
        .container > .row > .col {
          padding: 0;
        }
        @media (max-width: ${THEME.BREAKPOINTS.SM - 1}px) {
          .container > .row {
            grid-template-columns: 1fr;
          }
        }
        .container {
          padding-left: 0;
          padding-right: 0;
        }
        @media (min-width: 480px) {
          .container {
            padding-left: 15px;
            padding-right: 15px;
          }
        }
        .promptContainer {
          background-color: white;
          padding: 0;
          box-shadow: ${THEME.BOX_SHADOW.DEFAULT};
        }
      `}</style>
    </>
  )
}

export default FavoritesPageActionPrompt
